const updateTenants = {
  toastr: 'Tenant actualizado',
  toastr1: ' fue actualizado con éxito',
  toastrError: 'Tenant ya registrado',
  toastrError1: 'Ingrese otro nombre'
};

export default updateTenants;
